import React from 'react';
import classNames from 'classnames';
import gettext from '@eb/gettext';

import { Button } from '@eb/eds-button';
import { Icon } from '@eb/eds-icon';
import { ProgressIndicator } from '@eb/eds-progress-indicator';

import './LinkedAccountsGreyDialog.scss';

const HeaderIcon = ({ iconType, iconColor, isLoading }) => {
    const classes = classNames(
        'eds-l-mar-bot-6',
        'eds-fx--pop eds-fx--delay-1',
        'eds-bg-color--white',
        'authentication__page-header__icon',
        'eds-text--center',
    );

    let icon = (
        <ProgressIndicator
            size="medium-chunky"
            shape="circular"
            style="gradient"
        />
    );

    if (iconType && !isLoading) {
        icon = <Icon size="medium" type={iconType} color={iconColor} />;
    }

    return (
        <div className={classes} data-spec="page-header-icon">
            {icon}
        </div>
    );
};

// Renders a 'dialog' style message with a dark centered icon by default, two messages (one of wich is lighter in colour) and a darker link button
const LinkedAccountsGreyDialog = ({
    iconType,
    iconColor = 'grey-700',
    headerText,
    subtitleTextDark,
    subtitleText,
    buttonText,
    handleOnClick,
    isLoading,
}) => {
    const titleClasses = classNames(
        'eds-text--center',
        'eds-l-mar-bot-8',
        'eds-l-mar-hor-3',
    );
    const subTitleClasses = classNames(
        'eds-l-mar-bot-8',
        'eds-l-mar-hor-3',
        'eds-text-bm',
        'eds-text--center',
    );
    const graySubTitleClasses = classNames(
        subTitleClasses,
        'eds-text-color--grey-600',
    );

    return (
        <div className="authentication__dialog-message">
            <HeaderIcon
                iconType={iconType}
                iconColor={iconColor}
                isLoading={isLoading}
            />

            <h2 className={titleClasses}>{headerText}</h2>

            {subtitleTextDark && (
                <div className={subTitleClasses}>{subtitleTextDark}</div>
            )}

            {subtitleText && (
                <div className={graySubTitleClasses}>{subtitleText}</div>
            )}

            {buttonText && (
                <div className="eds-align--center-horizontal">
                    <Button
                        style="link"
                        onClick={handleOnClick}
                        __containerClassName="authentication__button--grey"
                    >
                        {buttonText}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default LinkedAccountsGreyDialog;
